import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimatedSvgComponent } from './animated-svg.component';
import { BackButtonModule } from '../../shared/directives/backBtn/backBtn.module';

@NgModule({
  declarations: [AnimatedSvgComponent],
  imports: [
    CommonModule,

    BackButtonModule
  ],
  exports: [AnimatedSvgComponent]
})
export class AnimatedSvgModule { }
